module.exports = __webpack_public_path__ + "static/media/icon_unique-data.51d6ec01.svg";